import qs from "qs";

export function getUrlParams(location) {
  return qs.parse(location.search, { ignoreQueryPrefix: true });
}
